export const initialState = {
  user: null,
  // cart: [
  //   { productId: 'price_1IS7prI6sOCxVA9Bq5TsWV1c', quantity: 1 },
  //   { productId: 'price_1IS7pRI6sOCxVA9Bt550Iwac', quantity: 2 }
  // ],
  customizer: [],
  products: [
    // {
    //   id: 'price_1IS7prI6sOCxVA9Bq5TsWV1c',
    //   name: 'Red Wine',
    //   short: 'Lorem LoremLorem Lorem Lorem',
    //   description:
    //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    //   image: '/WineBottles/Red wine.png',
    //   price: 60
    // },
    // {
    //   id: 'price_1IS7pRI6sOCxVA9Bt550Iwac',
    //   name: 'White Wine',
    //   short: 'Lorem LoremLorem Lorem Lorem',
    //   description:
    //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    //   image: '/WineBottles/White wine.png',
    //   price: 60
    // },
    // {
    //   id: 'price_1IS7prI6sOCxVA9Bq5TsWV1c',
    //   name: 'Red Wine',
    //   short: 'Lorem LoremLorem Lorem Lorem',
    //   description:
    //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    //   image: '/WineBottles/Red wine.png',
    //   price: 60
    // },
    // {
    //   id: 'price_1IS7pRI6sOCxVA9Bt550Iwac',
    //   name: 'White Wine',
    //   short: 'Lorem LoremLorem Lorem Lorem',
    //   description:
    //     'Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua. Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat. Duis aute irure dolor in reprehenderit in voluptate velit esse cillum dolore eu fugiat nulla pariatur. Excepteur sint occaecat cupidatat non proident, sunt in culpa qui officia deserunt mollit anim id est laborum.',
    //   image: '/WineBottles/White wine.png',
    //   price: 60
    // }
  ],
};

export const actionTypes = {
  SET_USER: "SET_USER",
  ADD_TO_CART: "ADD_TO_CART",
  UPDATE_QUANTITY: "UPDATE_QUANTITY",
  UPDATE_CART: "UPDATE_CART",
  REMOVE_FROM_CART: "REMOVE_FROM_CART",
  UPDATE_PRODUCTS: "UPDATE_PRODUCTS",
  EMPTY_CART: "EMPTY_CART",
};

const reducer = (state, action) => {
  switch (action.type) {
    case actionTypes.SET_USER:
      return {
        ...state,
        user: action.user,
      };
    case actionTypes.ADD_TO_CART:
      console.log(action.product);
      const updatedCart = [...state.cart, action.product];
      return {
        ...state,
        cart: updatedCart,
      };
    case actionTypes.UPDATE_QUANTITY:
      const copyCart = state.cart.slice();
      const findProduct = copyCart.findIndex(
        (product) => product.labelId === action.labelId
      );
      copyCart[findProduct].quantity = action.quantity;
      return {
        ...state,
        cart: copyCart,
      };
      // to change product of item already in the cart (change a white wine to a red)
    case actionTypes.UPDATE_CART:
      const copyOfCart = action.cart;
      return {
        ...state,
        cart: copyOfCart,
      };
    case actionTypes.REMOVE_FROM_CART:
      const removeCart = state.cart.filter(
        (product) => product.labelId !== action.labelId
      );
      return {
        ...state,
        cart: removeCart,
      };

    case actionTypes.UPDATE_PRODUCTS:
      return {
        ...state,
        products: action.products,
      };

      case actionTypes.EMPTY_CART:
      return {
        ...state,
        cart: [],
      };

    default:
      return state;
  }
};

export default reducer;
